module.exports = __webpack_public_path__ + "img/logo-transparant.371efd96.png";